import React, { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useClickOutside from '@hooks/useClickOutside';

import FilterName from '@features/filter/v2/FilterName';

import { storeSelectedFilterCheckboxType, updateTextItemInGlobalFilter } from '@store/actions/FilterAction';

const BlockName = () => {
	// const filterData = useSelector((store) => store.filterFieldStore);
	const selectedField = useSelector((store) => store.slectedCheckBoxFieldStore);
	// const { dependentFilterList } = useSelector((store) => store.dependentFilterListStore);
	const dispatch = useDispatch();
	const checkboxRef = useRef();
	const [data, setData] = useState(null);

	// useEffect(() => {}, [dependentFilterList]);

	const onOutSideClick = () => {
		dispatch(storeSelectedFilterCheckboxType(null));
	};

	const handleChangeBlockName = (e) => {
		let { value, name } = e.target;
		let tempData = {
			name: 'blockName',
			type: 'text',
			key: value,
			value: value,
			identifier: name
		};
		setData(tempData);
	};

	const onApplyClick = () => {
		if (data) {
			dispatch(updateTextItemInGlobalFilter(data));
		}
		dispatch(storeSelectedFilterCheckboxType(null));
	};

	useClickOutside(checkboxRef, onOutSideClick);

	return (
		<div>
			<FilterName type="BLOCK_NAME" />
			{selectedField?.selectedCheckboxField === 'BLOCK_NAME' && (
				<div className="filter-submenu scroll-y-label" ref={checkboxRef}>
					<div className="card border-0">
						<div className="card-body">
							<div className="form-group">
								<input
									type="text"
									placeholder="Search"
									autoComplete="off"
									id="blocKName"
									onChange={(e) => handleChangeBlockName(e)}
								/>
							</div>
							<div className="d-flex justify-content-end gap-2">
								<button className="button outline size32" onClick={() => onOutSideClick()}>
									Cancel
								</button>
								<button className="button size32" onClick={() => onApplyClick()}>
									Apply
								</button>
							</div>
						</div>
					</div>
				</div>
			)}
		</div>
	);
};

export default BlockName;
